// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DataBaseActions;
(function (DataBaseActions) {
    DataBaseActions[DataBaseActions["None"] = 0] = "None";
    DataBaseActions[DataBaseActions["Add"] = 1] = "Add";
    DataBaseActions[DataBaseActions["Update"] = 2] = "Update";
    DataBaseActions[DataBaseActions["ToRemove"] = 3] = "ToRemove";
})(DataBaseActions || (DataBaseActions = {}));
